import { render, staticRenderFns } from "./UiLoading.vue?vue&type=template&id=17b0e5d2&scoped=true"
import script from "./UiLoading.vue?vue&type=script&lang=js"
export * from "./UiLoading.vue?vue&type=script&lang=js"
import style0 from "./UiLoading.vue?vue&type=style&index=0&id=17b0e5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0e5d2",
  null
  
)

export default component.exports